import { createStyles, makeStyles, Theme, fade } from '@material-ui/core/styles';

import { colorsPalette, SMALL_MARGIN } from '../../../../theme';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    wrapper: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      marginTop: SMALL_MARGIN,
      padding: 24,
      backgroundColor: colorsPalette.violetAnalyticsCard,
      flexDirection: 'column',
      borderRadius: 5,
      boxShadow: `0px 3px 5px ${colorsPalette.black}`,
      [theme.breakpoints.up('md')]: {
        flexDirection: 'row',
      },
    },
    btn: {
      '&:hover': {
        '& $repeatIcon': {
          color: fade(colorsPalette.black, 0.87),
        },
        '& $playIcon path': {
          stroke: fade(colorsPalette.black, 0.87),
        },
      },
    },
    buttonIcon: {
      width: 14,
      height: 14,
      marginRight: 9,
      transition: 'all 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
    },
    repeatIcon: {},
    playIcon: {},
  }),
);
export default useStyles;
